<template>
  <tr>
    <td>
      <UserLinkByText :value="item" />
    </td>
    <td class="right">{{rcpCount}}</td>
    <td class="right">{{gameUseBrain.brainRequestCount}}</td>
    <td class="right">{{gameUseBrain.brainRequestUserCount}}</td>
    <td class="right">{{gameUseBrain.brainCompleteCount}}</td>
    <td class="right">{{gameUseBrain.brainCompleteUserCount}}</td>
    <td class="right">{{gameUseBrain.brainAverageScore}}</td>
    <td class="right">{{gameUseDementia.dementiaRequestCount}}</td>
    <td class="right">{{gameUseDementia.dementiaRequestUserCount}}</td>
    <td class="right">{{gameUseDementia.dementiaCompleteCount}}</td>
    <td class="right">{{gameUseDementia.dementiaCompleteUserCount}}</td>
    <td class="right">{{gameUseDementiaStep.dementiaStepOneCount}}</td>
    <td class="right">{{gameUseDementiaStep.dementiaStepTwoCount}}</td>
    <td class="right">{{gameUseDementiaStep.dementiaStepThreeCount}}</td>
    <td class="right">{{gameUseDementiaStep.dementiaStepFourCount}}</td>
  </tr>
</template>

<script>
import statsMixin from "$views/Stats/v2/_mixin";
export default {
  mixins: [statsMixin],
  props: {
    item: String,
    rcpCount: Number,
    gameUseBrain: Object,
    gameUseDementia: Object,
    gameUseDementiaStep: Object
  }
};
</script>